import { QaiSegmentedBarGraphKind } from '@qai/ui';
import { SCORE_KIND, SCORE_KIND_THRESHOLDS } from './constants/reporting-dashboard/score-kind.constants';

export function getTabScoreKind(
  value: number,
  criteria: number,
): 'success' | 'warning' | 'error' {
  const roundedValue = Number(value.toFixed(1));
  const roundedCriteria = Number(criteria.toFixed(1));
  const warningThreshold = Number((roundedCriteria - 1).toFixed(1));

  if (roundedCriteria <= 0) return 'success';

  if (roundedValue >= roundedCriteria) {
    return 'success';
  }

  if (roundedValue >= warningThreshold) {
    return 'warning';
  }

  return 'error';
}

export function getKindByPercentage(percentage: number): QaiSegmentedBarGraphKind {
  if (percentage < SCORE_KIND_THRESHOLDS.WARNING_MAX) return SCORE_KIND.WARNING;
  if (percentage < SCORE_KIND_THRESHOLDS.INFO_MAX) return SCORE_KIND.INFO;
  return SCORE_KIND.SUCCESS;
}
